import type { AxiosResponse } from 'axios';
import type { Condition, OnError } from '@/composables/AxiosResponseInterceptor';

const passThroughResponseHandler = async (response: AxiosResponse) => response;

/**
 * Same functionality as `useAxiosResponseErrorInterceptor`, but has pass-through response handler
 * included so that only the error handler has to be added.
 */
export const useAxiosResponseErrorInterceptor = (condition: Condition, onError: OnError) =>
  useAxiosResponseInterceptor(condition, passThroughResponseHandler, onError);
